// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.fui-Button.feedback-button{color:#6859f0;border-color:#6859f0;height:35px}", "",{"version":3,"sources":["webpack://./src/taskpane/pages/HelpPage.scss"],"names":[],"mappings":"AAAA,kCACE,aAAA,CACA,oBAAA,CACA,WAAA","sourcesContent":["button.fui-Button.feedback-button {\n  color: #6859f0;\n  border-color: #6859f0;\n  height: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
